import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import configImages from '../../../../config/configImages';
import MenuBar from '../../../Layout/sidebar/menubar';
import fetchMethodRequest from '../../../../config/service';
import showToasterMessage from '../../../UI/ToasterMessage/toasterMessage';
import configMessages from '../../../../config/configMessages';
import { TypingLoader } from './typingLoader';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button } from 'primereact/button';
import ReadAloud from '../../CommonComponents/ReadAloud';
import CopyText from '../../CommonComponents/CopyText';
import { marked } from 'marked';
import apiCalls from '../../../../config/apiCalls';
import { Controller, useForm } from 'react-hook-form';
import DoFileUpload from '../../../Form/Fields/DoFileUpload';
import Loader from '../../../App/Loader';
import config from '../../../../config/config';
import { Card, CardBody } from 'reactstrap';
import { SummaryLoader } from './SummarizeLoader';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Badge } from 'primereact/badge';

const GroupedResultsViewer = ({ groupedResults }) => {
  if (!groupedResults || groupedResults.length === 0) return null;

  const getRiskColor = (riskFactors) => {
    if (!riskFactors || riskFactors.length === 0) return 'success';
    if (riskFactors.length < 3) return 'warning';
    return 'danger';
  };

  return (
    <div className="grouped-results-container mt-3">
      <h5 className="mb-3"><FontAwesomeIcon icon="layer-group" className="me-2" /> Hierarchical Uniqueness Analysis</h5>
      <Accordion multiple activeIndex={[0]}>
        {groupedResults.map((group, idx) => (
          <AccordionTab
            key={idx}
            header={
              <div className="d-flex align-items-center justify-content-between w-100 pe-3">
                <span>
                  <Badge value={group.category} severity="info" className="me-2" />
                  <i className="pi pi-arrow-right mx-2 text-secondary" style={{ fontSize: '0.8rem' }}></i>
                  <Badge value={group.subcategory} severity="secondary" />
                </span>
                <Badge value={"cases" + ":" + group.totalCases} severity="contrast" className="ms-2" style={{ fontSize: '12px' }} />

              </div>
            }
          >
            <div className="subgroup-card p-3 rounded" style={{ backgroundColor: '#ffffff', border: '1px solid #e2e8f0', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.03)' }}>
              <div className="mb-4">
                <h6 className="text-primary mb-2">
                  <FontAwesomeIcon icon="trophy" className="me-2 text-warning" /> Most Unique Case
                </h6>
                <div className="p-3 rounded" style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <strong className="text-dark fs-5">{group.uniqueCase.fileName}</strong>
                    <Badge value={`Uniqueness: ${(group.uniqueCase.uniquenessScore * 100).toFixed(0)}%`} severity="success" size="large" />
                  </div>

                  <div className="mt-3">
                    {group.uniqueCase.outcomeStatus && group.uniqueCase.outcomeStatus.toUpperCase() !== 'UNKNOWN' && (
                      <Badge value={group.uniqueCase.outcomeStatus.toUpperCase()} severity={getRiskColor(group.uniqueCase.failureSignals)} className="me-2 mb-2" />
                    )}
                    {group.uniqueCase.riskFactors?.slice(0, 2).map((risk, i) => (
                      <Badge key={i} value={risk.substring(0, 30) + '...'} severity="danger" className="me-2 mb-2" />
                    ))}
                  </div>

                  {group.aiExplanation && (
                    <div className="mt-3 p-3 rounded" style={{ backgroundColor: '#eff6ff', borderLeft: '3px solid #3b82f6' }}>
                      <h6 className="text-primary mb-2">
                        <FontAwesomeIcon icon="robot" className="me-2" /> AI Explanation
                      </h6>
                      <div className="text-secondary" style={{ fontSize: '0.9rem' }} dangerouslySetInnerHTML={{ __html: marked(group.aiExplanation) }}></div>
                    </div>
                  )}
                </div>
              </div>

              <div>
                <h6 className="text-secondary mb-2">
                  <FontAwesomeIcon icon="list" className="me-2" /> Cases in this Subgroup
                </h6>
                <ul className="list-group list-group-flush rounded">
                  {group.rankedCases.map((c, i) => (
                    <li
                      key={i}
                      className="list-group-item bg-transparent text-dark border-light d-flex justify-content-between align-items-center px-2 py-1"
                      style={{ fontSize: '0.9rem' }}
                    >
                      <span>
                        {i === 0 && <i className="pi pi-star-fill text-warning me-2" style={{ fontSize: '0.7rem' }}></i>} {c.fileName}
                      </span>
                      <span className="text-secondary">{(c.uniquenessScore * 100).toFixed(0)}%</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </AccordionTab>
        ))}
      </Accordion>
    </div>
  );
};

const Search = (props) => {
  const [messages, setMessages] = useState([]);
  let messagesRef = useRef([])
  const [input, setInput] = useState('');
  const chatHistoryRef = useRef(null);
  const overlayRef = useRef(null);
  const noProfileImage = configImages.defaultImg;
  const [fileChatId, setFileChatId] = useState({ chatId: '' });

  // Mentions State
  const [mentionSearchText, setMentionSearchText] = useState('');
  const [mentionResults, setMentionResults] = useState([]);
  const [isMentioning, setIsMentioning] = useState(false);
  const [selectedMentions, setSelectedMentions] = useState([]);
  const [activeMentionIndex, setActiveMentionIndex] = useState(0);
  const [mentionRange, setMentionRange] = useState(null);

  const { chatId } = props?.fileDetails?.chatId ? props?.fileDetails : fileChatId?.chatId ? fileChatId : useParams();
  let filterRef = useRef({ "page": 1, "limit": 20, "sortfield": "created", "direction": "desc", "criteria": [{ "key": "chatId", "value": chatId, "type": "eq" }] })
  const [totalCount, setTotalCount] = useState(0)
  let newMessageRef = useRef();
  let previousScrollHeightRef = useRef();
  const [disableButton, setDisableButton] = useState(false);
  const [isInitialLoaded, setIsInitialLoaded] = useState(false);
  let chatIdRef = useRef(chatId);
  let inputRef = useRef(null);
  const { control, formState, reset } = useForm()
  const { errors } = formState;
  const [activeSpeechMessageId, setActiveSpeechMessageId] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const { chat } = location.state || {};
  const Navigate = useNavigate();
  const [archivedChats, setArchivedChat] = useState()
  const [files, setFiles] = useState([])
  const [recommendedQuestions, setRecommendedQuestions] = useState([])
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get('type');
  const isFolder = !props.fileDetails?.details?.type;
  const getSummaryFileUpload = () => {
    return {
      name: "multiFile",
      fieldName: "multiFile",
      type: "fileUpload",
      placeholder: "MultiFile",
      label: "Upload and Summarize",
      width: "120px",
      addFormOrder: 10,
      editFormOrder: 10,
      stringType: null,
      derivedValue: "multiFile=undefined",
      capitalizeTableText: false,
      sortable: false,
      filter: false,
      id: "multiFile",
      displayinaddForm: "true",
      displayineditForm: "true",
      displayinlist: "true",
      isFieldRequired: "false",
      isMultipleRequired: false,
      required: false,
      globalSearchField: "true",
      controllerId: null,
      fieldType: "fileUpload",
      imagePath: "Files",
      show: true,
      showOrHideFields: [],
      mobile: true,
      displayInSettings: true,
      isAddFormHidden: false,
      isEditFormHidden: true,
      isMultiple: true,
    }
  }

  const getUniqueSetCasesFileUpload = () => {
    return {
      name: "uniqueSetCasesMultiFile",
      fieldName: "uniqueSetCasesMultiFile",
      type: "fileUpload",
      placeholder: "MultiFile",
      label: "Upload for Unique Set Cases",
      width: "120px",
      addFormOrder: 10,
      editFormOrder: 10,
      stringType: null,
      derivedValue: "uniqueSetCasesMultiFile=undefined",
      capitalizeTableText: false,
      sortable: false,
      filter: false,
      id: "uniqueSetCasesMultiFile",
      displayinaddForm: "true",
      displayineditForm: "true",
      displayinlist: "true",
      isFieldRequired: "false",
      isMultipleRequired: false,
      required: false,
      globalSearchField: "true",
      controllerId: null,
      fieldType: "fileUpload",
      imagePath: "Files",
      show: true,
      showOrHideFields: [],
      mobile: true,
      displayInSettings: true,
      isAddFormHidden: false,
      isEditFormHidden: true,
      url: 'case-prediction/unique-case',
      isMultiple: true,
      assingValueToForm: {
        message: "Find the unique case from these uploaded documents and explain whether it is unique because of success, failure, risk, facts, strategy, or legal category.",
        tool_name: "case_unique_discovery",
        chatId: "new",
        chatType: "Private AI",
        conversationType: "Upload and Summarize"
      }
    }
  }

  useEffect(() => {
    let obj = Object.assign(filterRef.current, { "page": 1, "criteria": [{ "key": "chatId", "value": chatId, "type": "eq" }] });
    filterRef.current = obj;
    chatIdRef.current = chatId;
    inputRef.current && inputRef.current.focus();
    setMessages([]);
    setIsInitialLoaded(false)
    messagesRef.current = [];
    if (chat && chat.files) {
      setFiles(chat.files);
    } else {
      setFiles([])
    }
    setTimeout(() => {
      insertMessages(obj)
    }, 200);
    if (recommendedQuestions?.length > 0) {
      setRecommendedQuestions([])
    }
  }, [chatId])

  useEffect(() => {
    if (chat?.files?.length > 0) {
      setFiles(chat.files)
    }
  }, [chat]);

  const getMentionId = (entity) => entity?.id || entity?._id || entity?.fileId || entity?.folderId || entity?.name;
  const getMentionName = (entity) => entity?.name || entity?.fileName || entity?.title || 'Untitled';
  const getMentionType = (entity) => (entity?.type || entity?.entityType || 'file').toLowerCase();
  const getMentionPath = (entity) => entity?.path || entity?.parentFolderIdSearch || entity?.folderPath || entity?.location || '';

  const getCaretPosition = (element) => {
    const selection = window.getSelection();
    if (!element || !selection || selection.rangeCount === 0) return 0;

    const range = selection.getRangeAt(0);
    let position = 0;
    let foundCaret = false;

    const getNodeTextLength = (node) => {
      if (node.nodeType === Node.TEXT_NODE) return (node.textContent || '').length;
      if (node.nodeType !== Node.ELEMENT_NODE) return 0;
      if (node.dataset?.mentionName) return node.dataset.mentionName.length + 1;

      return Array.from(node.childNodes).reduce((total, childNode) => total + getNodeTextLength(childNode), 0);
    };

    const walkNodes = (node) => {
      if (foundCaret) return;

      if (node === range.startContainer) {
        if (node.nodeType === Node.TEXT_NODE) {
          position += range.startOffset;
        } else {
          Array.from(node.childNodes).slice(0, range.startOffset).forEach((childNode) => {
            position += getNodeTextLength(childNode);
          });
        }
        foundCaret = true;
        return;
      }

      if (node.contains?.(range.startContainer)) {
        node.childNodes.forEach(walkNodes);
        return;
      }

      position += getNodeTextLength(node);
    };

    element.childNodes.forEach(walkNodes);
    return position;
  };

  const getEditorText = () => {
    if (!inputRef.current) return '';

    const readNodeText = (node) => {
      if (node.nodeType === Node.TEXT_NODE) return node.textContent || '';
      if (node.nodeType !== Node.ELEMENT_NODE) return '';
      if (node.dataset?.mentionName) return `@${node.dataset.mentionName}`;

      return Array.from(node.childNodes).map(readNodeText).join('');
    };

    return Array.from(inputRef.current.childNodes).map(readNodeText).join('').replace(/\u00a0/g, ' ');
  };

  const createMentionToken = (entity) => {
    const token = document.createElement('span');
    const icon = document.createElement('span');
    const label = document.createElement('span');
    const mentionType = getMentionType(entity);

    token.className = 'mention-inline-token';
    token.contentEditable = 'false';
    token.dataset.mentionId = getMentionId(entity);
    token.dataset.mentionName = getMentionName(entity);
    token.dataset.mentionType = mentionType;

    icon.className = `mention-inline-icon mention-inline-icon--${mentionType} pi ${mentionType === 'folder' ? 'pi-folder' : 'pi-file'}`;
    icon.setAttribute('aria-hidden', 'true');

    label.className = 'mention-inline-label';
    label.textContent = getMentionName(entity);

    token.appendChild(icon);
    token.appendChild(label);
    return token;
  };

  const getTextNodeRange = (element, start, end) => {
    const range = document.createRange();
    let currentPosition = 0;
    let startSet = false;
    let endSet = false;

    const walkNodes = (node) => {
      if (endSet) return;

      if (node.nodeType === Node.TEXT_NODE) {
        const nodeText = node.textContent || '';
        const nextPosition = currentPosition + nodeText.length;

        if (!startSet && start <= nextPosition) {
          range.setStart(node, Math.max(0, start - currentPosition));
          startSet = true;
        }

        if (!endSet && end <= nextPosition) {
          range.setEnd(node, Math.max(0, end - currentPosition));
          endSet = true;
        }

        currentPosition = nextPosition;
        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE && node.dataset?.mentionName) {
        currentPosition += node.dataset.mentionName.length + 1;
        return;
      }

      node.childNodes.forEach(walkNodes);
    };

    walkNodes(element);

    if (!startSet) {
      range.selectNodeContents(element);
      range.collapse(false);
    }

    if (!endSet) {
      range.setEnd(range.startContainer, range.startOffset);
    }

    return range;
  };

  const replaceEditorRangeWithMention = (start, end, entity) => {
    const editor = inputRef.current;
    if (!editor) return 0;

    const range = getTextNodeRange(editor, start, end);
    const token = createMentionToken(entity);
    const trailingSpace = document.createTextNode(' ');

    range.deleteContents();
    range.insertNode(trailingSpace);
    range.insertNode(token);

    const selection = window.getSelection();
    const caretRange = document.createRange();
    caretRange.setStartAfter(trailingSpace);
    caretRange.collapse(true);
    selection.removeAllRanges();
    selection.addRange(caretRange);

    return start + getMentionName(entity).length + 2;
  };

  // Debounced API call for mentions
  useEffect(() => {
    if (!isMentioning) {
      setMentionResults([]);
      return;
    }
    const timer = setTimeout(() => {
      fetchMethodRequest('GET', `${apiCalls.mentionEntities}?q=${encodeURIComponent(mentionSearchText)}`)
        .then((res) => {
          if (res && res.results) {
            setMentionResults(res.results);
            setActiveMentionIndex(0);
          } else {
            setMentionResults([]);
          }
        })
        .catch((err) => {
          console.error("Mention search error", err);
          setMentionResults([]);
        });
    }, 300);
    return () => clearTimeout(timer);
  }, [mentionSearchText, isMentioning]);

  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const isMentionInInput = (text, mention) => {
    const mentionPattern = new RegExp(`(^|\\s)@${escapeRegExp(getMentionName(mention))}(?=\\s|$|[.,!?;:)\\]])`);
    return mentionPattern.test(text);
  };

  const updateMentionState = (value, cursorPosition) => {
    const textBeforeCursor = value.substring(0, cursorPosition);
    const match = textBeforeCursor.match(/(^|[\s([{])@([^@\n]{0,80})$/);

    if (match) {
      const start = match.index + match[1].length;
      const query = match[2];
      const completedMention = selectedMentions.find((mention) => {
        const mentionName = getMentionName(mention);
        return query === mentionName || query.startsWith(`${mentionName} `);
      });

      if (completedMention) {
        setIsMentioning(false);
        setMentionSearchText('');
        setMentionRange(null);
        setActiveMentionIndex(0);
        return;
      }

      setIsMentioning(true);
      setMentionSearchText(query);
      setMentionRange({ start, end: cursorPosition });
    } else {
      setIsMentioning(false);
      setMentionSearchText('');
      setMentionRange(null);
      setActiveMentionIndex(0);
    }
  };

  const handleComposerInput = () => {
    const val = getEditorText();
    const caretPosition = getCaretPosition(inputRef.current);
    setInput(val);
    setSelectedMentions((mentions) => mentions.filter((mention) => isMentionInInput(val, mention)));
    updateMentionState(val, caretPosition);
  };

  useEffect(() => {
    if (input === '' && inputRef.current && getEditorText() !== '') {
      inputRef.current.innerHTML = '';
    }
  }, [input]);

  const handleMentionSelect = (entity) => {
    const entityId = getMentionId(entity);

    if (!selectedMentions.find(m => getMentionId(m) === entityId)) {
      setSelectedMentions([...selectedMentions, entity]);
    }

    const cursorPosition = inputRef.current ? getCaretPosition(inputRef.current) : input.length;
    const range = mentionRange || { start: cursorPosition, end: cursorPosition };
    replaceEditorRangeWithMention(range.start, range.end, entity);
    setInput(getEditorText());

    setIsMentioning(false);
    setMentionSearchText('');
    setMentionRange(null);
    setActiveMentionIndex(0);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  const removeMention = (idToRemove) => {
    const removedMention = selectedMentions.find(m => getMentionId(m) === idToRemove);
    setSelectedMentions(selectedMentions.filter(m => getMentionId(m) !== idToRemove));
    if (removedMention) {
      const editor = inputRef.current;
      const token = Array.from(editor?.querySelectorAll('[data-mention-id]') || [])
        .find((mentionToken) => mentionToken.dataset.mentionId === String(idToRemove));
      if (token) {
        const nextSibling = token.nextSibling;
        if (nextSibling?.nodeType === Node.TEXT_NODE && nextSibling.textContent.startsWith(' ')) {
          nextSibling.textContent = nextSibling.textContent.substring(1);
        }
        token.remove();
        setInput(getEditorText().replace(/\s{2,}/g, ' ').trimStart());
      } else {
        const mentionPattern = new RegExp(`(^|\\s)@${escapeRegExp(getMentionName(removedMention))}(?=\\s|$|[.,!?;:)\\]])`);
        setInput((value) => value.replace(mentionPattern, (match, prefix) => prefix).replace(/\s{2,}/g, ' ').trimStart());
      }
    }
  };

  const handleInputKeyDown = (e) => {
    if (isMentioning && mentionResults.length > 0) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActiveMentionIndex((index) => (index + 1) % mentionResults.length);
        return;
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActiveMentionIndex((index) => (index - 1 + mentionResults.length) % mentionResults.length);
        return;
      }
      if (e.key === 'Enter' || e.key === 'Tab') {
        e.preventDefault();
        handleMentionSelect(mentionResults[activeMentionIndex]);
        return;
      }
    }

    if (isMentioning && e.key === 'Escape') {
      e.preventDefault();
      setIsMentioning(false);
      setMentionSearchText('');
      setMentionRange(null);
      return;
    }

    if (e.key === 'Enter') {
      e.preventDefault();
      handleSend();
    }
  };

  const handleComposerPaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text/plain');
    document.execCommand('insertText', false, pastedText);
  };

  useEffect(() => {
    if (chatHistoryRef.current && (filterRef.current?.page === 1 || newMessageRef.current)) {
      newMessageRef.current = false
      chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
    } else {
      if (chatHistoryRef?.current) {
        chatHistoryRef.current.scrollTop = chatHistoryRef?.current.scrollHeight - previousScrollHeightRef.current;
      }

    }
  }, [messages]);

  const createChat = (resp) => {
    if (overlayRef?.current) {
      overlayRef.current?.createChat(true, resp)
    }
  }

  const updateLastMessage = (res = {
    messages: {
      question: input, answer: `
        <div class="alert alert-danger text-center" role="alert">
            ${configMessages.deafultErrorMessage}
        </div>` , 'type': 'error'
    }
  }) => {
    let updatedMessages = messages
    if (messages[messages.length - 1]?.answer === 'loader') {
      updatedMessages = messages.slice(0, -1);
      updatedMessages.push(res.messages)
    }
    else {
      updatedMessages.push(res.messages)
    }
    setMessages([...updatedMessages]);
  }

  const handleSend = (event, query, type) => {
    if (!type) {
      if (!input || disableButton) {
        return;
      }
    }
    if (type == 'regenerate' || type == 'recommended_question') {
      if (!query || disableButton) {
        return
      }
    }
    let url;
    if (!props.fileChat) {
      if (chatId) {
        url = `${apiCalls.fileRead}?chatId=${chatId}`
      } else {
        url = apiCalls.fileRead
      }
    } else {
      const baseUrl = isFolder ? apiCalls.askQuestionFolder : apiCalls.askQuestion; if (chatId) {
        url = `${baseUrl}?chatId=${chatId}`
      } else {
        url = baseUrl;
      }
    }
    let body = {
      "query": query ? query?.trim() : input?.trim(),
      "mentions": selectedMentions
    }

    if (chat?.conversationType === "Upload and Summarize" && chatId) {
      url = `${apiCalls.fileRead}?chatId=${chatId}`
      body.conversationType = "Upload and Summarize"
    }
    if (props.fileChat) {
      body[isFolder ? 'folderId' : 'fileId'] = isFolder ? props.fileDetails?.details?._id : props.fileDetails?.fileId;
    }
    setDisableButton(true);
    const userMessage = { question: query ? query : input, answer: 'loader' };
    setInput('');
    // Do not clear selectedMentions here, wait until response or explicitly clear if desired.
    // Actually, typical chat UI keeps mentions for the context, but let's clear them after send to reset for next message.
    setSelectedMentions([]);
    setMessages([...messages, userMessage]);
    fetchMethodRequest('POST', url, body)
      .then((res) => {
        if (chatIdRef.current && res?.messages?.chatId && res?.messages?.chatId !== chatIdRef.current) {
          setDisableButton(false);
          if (isLoading) {
            setIsLoading(false);
          }
          return
        }
        if (res && res.messages) {
          newMessageRef.current = true;
          updateLastMessage(res)
          if (!chatIdRef.current) {
            createChat(res)
          }
          if (res && res?.chatId) {
            setFileChatId({ chatId: res.chatId })
          }
          if (res.messages?.recommended_questions && res.messages?.recommended_questions instanceof Array) {
            setRecommendedQuestions(res.messages.recommended_questions)
          }
        } else {
          updateLastMessage()
        }
        setDisableButton(false)
      }).catch((err) => {
        console.error("Fetch error:", err);
        updateLastMessage()
        showToasterMessage(configMessages.deafultErrorMessage, 'error');
      });
  };

  function insertMessages(defaultFilter) {
    let finalFilter = defaultFilter ? defaultFilter : filterRef.current;
    if (!chatId) return;
    fetchMethodRequest('GET', `${apiCalls.messages}?filter=${JSON.stringify(finalFilter)}`).then(async (resp) => {
      if (resp && resp.messages?.length > 0) {
        if (resp.pagination?.page) {
          if (resp.pagination?.page === 1) setIsInitialLoaded(true);
          let obj = Object.assign(finalFilter, { "page": resp.pagination?.page });
          filterRef.current = obj
        }
        if (resp.pagination?.totalCount) {
          setTotalCount(resp.pagination?.totalCount)
        }
        if (finalFilter.page === 1) {
          messagesRef.current = resp.messages?.reverse()
          setMessages(messagesRef.current);
        } else {
          previousScrollHeightRef.current = chatHistoryRef.current?.scrollHeight;
          messagesRef.current = [...resp.messages?.reverse(), ...messagesRef.current]
          setMessages(messagesRef.current);
        }
      }
    })
  };

  const onScrollTop = (e) => {
    const bottom = e.target.scrollTop == 0;
    if (bottom && messages.length < totalCount && isInitialLoaded) {
      let currentFilter = JSON.parse(JSON.stringify(filterRef.current))
      currentFilter.page = currentFilter.page + 1;
      insertMessages(currentFilter)

    }
  }


  const handleActiveSpeechMessage = (messageId) => {
    setActiveSpeechMessageId(messageId)
  }


  const handleRegenerate = (message) => {
    handleSend('', message.question, 'regenerate')
  }

  const onUploadAndSummarize = (response) => {
    if (response) {
      createChat(response)
    }
  }

  const onUniqueSetCasesUpload = (response) => {
    if (response && response.success && response.chatId) {
      showToasterMessage("Unique case discovery complete", 'success');
      createChat(response);
    } else {
      showToasterMessage(response?.message || "Failed to analyze files for unique cases", 'error');
    }
  }


  const showLoaderAndDisable = (value) => {
    setIsLoading(value)
    setDisableButton(value)
  }

  let getFileUpload = (i, item) => {
    const chooseOptions = {
      icon: 'pi pi-upload',
      iconOnly: false,
      className: 'custom-fileupload'
    };
    const bytesPerMB = 1024 * 1024;
    let fileSize = item.maxFileSize * bytesPerMB;
    let url = item.url || 'files/uploadAndSummarize?type=files';
    return (
      <div>
        <Controller
          name={item.name}
          control={control}
          render={({ field, fieldState }) => (
            <DoFileUpload
              url={url}
              formType={'add'}
              showPreview={true}
              input={field}
              id={field.id}
              label={item.label}
              name={field.name}
              field={field}
              fieldState={fieldState}
              errors={errors}
              type={'Public AI'}
              isMultiple={item.isMultiple !== undefined ? item.isMultiple : false}
              maxFileSize={fileSize}
              hideLabel={true}
              autoSubmit={true}
              modeType={'basic'}
              chooseOptions={chooseOptions}
              item={item}
              onSuccess={(response) => {
                if (item.name === 'uniqueSetCasesMultiFile') {
                  onUniqueSetCasesUpload(response);
                } else {
                  onUploadAndSummarize(response);
                }
              }}
              customFunction={showLoaderAndDisable}
              parameters={{ beforeUpload: true, afterUpload: false }}
              assingValueToForm={item.assingValueToForm}
            />)}
        />
      </div>
    )
  }

  const generateResponse = (question, ind) => {
    if (disableButton) return
    if (ind !== -1) {
      let filteredQuestions = recommendedQuestions.filter((ele, index) => ind !== index)
      setRecommendedQuestions(filteredQuestions)
    }
    handleSend('', question, 'recommended_question')
  }
  const GridBoxes = () => {
    return (
      <>
        <div>
          {type == "archive" && <h3 className='context-text'>Please Un-Archive chats Before Opening</h3>}

        </div>
        <div className="ai-grid-container">
          {/* Translation Box */}
          <div className="grid-box" onClick={(e) => { e.preventDefault(); Navigate('/translations') }} >
            <div>
              <div className="grid-box__title">Document Translation</div>
              <div className="grid-box__description">Translate the file to your selected language</div>
            </div>
            <Link
              to="/translations"
              className="grid-box__action"
              onClick={(e) => e.stopPropagation()}
            >
              <i className="fas fa-exchange-alt"></i> Translate
            </Link>
          </div>

          {/* Comparison Box */}
          <div className="grid-box" onClick={(e) => { e.preventDefault(); Navigate('/comparefiles ') }}>
            <div>
              <div className="grid-box__title">File Comparison</div>
              <div className="grid-box__description">Compare two case files to identify differences. </div>
            </div>
            <Link
              to="/comparefiles"
              className="grid-box__action"
              onClick={(e) => e.stopPropagation()}
            >
              <i className="fas fa-columns"></i> Compare
            </Link>

          </div>

          {/* Case Prediction Box */}
          <div className="grid-box" onClick={(e) => { e.preventDefault(); Navigate('/casePredictAI') }}>
            <div>
              <div className="grid-box__title">Case Predict AI</div>
              <div className="grid-box__description">Advanced legal analysis for case outcome predictions.</div>
            </div>
            <Link
              to="/casePredictAI"
              className="grid-box__action"
              onClick={(e) => e.stopPropagation()}
            >
              <i className="fas fa-gavel"></i> Predict
            </Link>
          </div>



          {/* File Upload Box */}
          <div className="grid-box">
            <div>
              <div className="grid-box__title">Upload Files</div>
              <div className="grid-box__description">Get the summary of uploaded file</div>
            </div>
            <div className="grid-box__action grid-box__upload-action" onClick={(e) => e.stopPropagation()}>
              {getFileUpload(-1, getSummaryFileUpload())}
            </div>
          </div>

          {/* Unique Set Cases Box */}
          <div className="grid-box">
            <div>
              <div className="grid-box__title">Unique Set Cases</div>
              <div className="grid-box__description">Upload multiple files for unique set cases</div>
            </div>
            <div className="grid-box__action grid-box__upload-action" onClick={(e) => e.stopPropagation()}>
              {getFileUpload(-1, getUniqueSetCasesFileUpload())}
            </div>
          </div>
        </div>
      </>
    );
  };
  return (
    <div className={(props.fileChat ? ' file-chat-box' : 'summary-search-containar')} >
      <div className='d-flex align-items-center col-sm-12 col-md-12 col-lg-12'>
        {!props?.hideMenu && <MenuBar setMessages={setMessages} chatId={chatId} archivedChats={archivedChats} ref={overlayRef} setArchivedChat={setArchivedChat} type={type} searchType={'privateAi'} defaultSearchFilter={{ key: 'chatType', value: "Private AI", type: 'eq' }} shareChats={false} />}
        <div className={(props.fileChat ? 'col-sm-12 col-md-12 col-lg-12' : 'col-sm-9 ') + 'justify-content-center align-items-center '} >
          <div className={"chatbot-container"} >
            {chatId && chatId.length > 0 && !props?.fileChat && <div className='d-flex justify-content-end align-items-center gap-2 button-options mb-3 pe-2  '>
              <>
                {getFileUpload(-1, getSummaryFileUpload())}
                {getFileUpload(-1, getUniqueSetCasesFileUpload())}
                <Button size="sm" data-toggle='tool-tip'
                  title='Transalte Files'>
                  <Link to={'/translations'} className='color-white'>
                    <FontAwesomeIcon
                      icon="file-prescription"
                      size='1x'
                    /> Translate Files
                  </Link>
                </Button >
                <Button size="sm" data-toggle='tool-tip'
                  title='comparefiles'>
                  <Link to={'/comparefiles'} className='color-white'>
                    <FontAwesomeIcon
                      icon="file-contract"
                      size='1x'
                    /> Compare Files
                  </Link>
                </Button >
              </>

            </div>}


            {
              chatId || messages?.length > 0 ?
                <>
                  <div className="chatbot-messages" ref={chatHistoryRef} onScroll={onScrollTop}>
                    {props?.fileDetails && props?.fileDetails?.oneLineSummary?.length > 0 ? (
                      <div
                        className={`tableCardBody m-2 sd-lg about-file-card ${props.fileChat ? 'file-chat-bg' : ''
                          }`}
                      >
                        <h4 className="about-file-title">About File</h4>

                        <div
                          className="about-file-content"
                          dangerouslySetInnerHTML={{
                            __html: props?.fileDetails?.oneLineSummary
                              ? marked(props?.fileDetails?.oneLineSummary)
                              : ''
                          }}
                        />
                      </div>
                    ) : null}

                    <Loader customClass={'messages-loader'} loader={isLoading} />
                    <div className='d-flex justify-content-end align-items-center' key={'file'}>
                      {files?.length > 0 &&
                        <>
                          <div className={'message user text-align-right'}>
                            {files.map(file => {
                              const match = file.path.match(/\/server\/upload\/.*$/);
                              let cleanedPath = match ? match[0].slice(1) : file.path;
                              cleanedPath = cleanedPath.split('/').map(encodeURIComponent).join('/');
                              return <a href={config.imgUrl + cleanedPath} target='_blank'>
                                <Card className='folder-box p-0 mx-2 w-auto'>
                                  <CardBody className='tableCardBody text-align-left p-1 d-flex justify-content-between align-items-center' style={{ backgroundColor: "#f0f0f0", border: "none" }}>
                                    <FontAwesomeIcon
                                      icon={file.type === 'docx' ? 'file-word' : 'file-pdf'}
                                      className='iconsize'
                                      size='1x'
                                      style={{ color: file.type && file.type === 'pdf' ? 'brown' : (file.type === 'docx') ? '#1292ee' : 'inherit', backgroundColor: 'transparent', fontSize: '2rem' }}
                                      data-toggle='tool-tip'
                                      title='Settings'
                                    />
                                    <span style={{ color: 'black' }}>{file.name}</span>
                                  </CardBody>
                                </Card>
                              </a>
                            })}
                          </div>
                          <div className='icon-style mx-2'>
                            <img src={noProfileImage} alt="" />
                          </div>
                        </>
                      }

                    </div>

                    {messages.map((message, index) => (
                      <>
                        <div className='d-flex justify-content-end align-items-center' key={'question' + index}>
                          <div className={'message user'}>{message?.question}</div>
                          <div className='icon-style mx-2'>
                            <img src={noProfileImage} alt="" />
                          </div>
                        </div>
                        <div className='d-flex justify-content-start align-items-start' key={'answer' + index}>
                          <div className='icon-style mx-2 mt-1'>
                            <FontAwesomeIcon
                              className='genderIconAlignment'
                              color='white'
                              icon='comment-dots'
                              data-toggle="tool-tip"
                              title='Send'
                            />
                          </div>

                          {message?.answer && message?.answer !== 'loader' ?
                            <div className='message bot w-100'>
                              {message.groupedResults && message.groupedResults.length > 0 ? (
                                <GroupedResultsViewer groupedResults={message.groupedResults} />
                              ) : (
                                <div dangerouslySetInnerHTML={{ __html: message?.type !== 'error' ? marked(message.answer) : message.answer }} ></div>
                              )}
                              <div className='d-flex justify-content-start align-items-center gap-1 mt-1 message-options-container' style={index === messages.length - 1 ? { visibility: 'visible' } : {}}>
                                <span className='message-options'>
                                  <ReadAloud text={message.answer} onActivate={(msg) => handleActiveSpeechMessage(msg === 'cancel' ? null : message._id)} isActive={activeSpeechMessageId == message._id} />
                                </span>
                                <span className='message-options'>
                                  <CopyText text={message.answer} />
                                </span >
                                <span className='message-options'>
                                  <CopyText text={message.answer} copyType={'TextCopy'} iconName={'copy'} />
                                </span >
                                {/* future implementation */}
                                {false && <span className='message-options'>
                                  <FontAwesomeIcon
                                    icon='share'
                                    className='pl-1' size='lg'
                                    data-toggle="tool-tip" title="Share"
                                    style={{
                                      color: '#12225f'
                                    }}
                                  />
                                </span>}
                                {index === messages.length - 1 && <span className='message-options'>
                                  <FontAwesomeIcon
                                    icon='sync-alt'
                                    className='pl-1' size='lg'
                                    data-toggle="tool-tip" title="Regenerate"
                                    style={{
                                      color: '#12225f'
                                    }}
                                    onClick={() => handleRegenerate(message)}
                                  />
                                </span>}
                              </div>
                            </div>
                            :
                            <div className='message bot'>
                              <TypingLoader />
                            </div>
                          }

                        </div>
                      </>
                    ))}
                  </div>
                  {
                    recommendedQuestions?.length > 0 ?
                      <div className='d-flex justify-content-start gap-3 ms-3'>
                        {recommendedQuestions?.map((question, ind) => {
                          return <div className='questions' onClick={() => generateResponse(question, ind)}>
                            {question}
                          </div>
                        })}
                      </div>
                      : null
                  }

                </> :
                <>
                  {props?.fileDetails && props?.fileDetails?.oneLineSummary?.length > 0 ? (
                    <div
                      className={`tableCardBody m-2 sd-lg about-file-card ${props.fileChat ? 'file-chat-bg' : ''
                        }`}
                    >
                      <h4 className="about-file-title">About File</h4>

                      <div
                        className="about-file-content"
                        dangerouslySetInnerHTML={{
                          __html: props?.fileDetails?.oneLineSummary
                            ? marked(props?.fileDetails?.oneLineSummary)
                            : ''
                        }}
                      />
                    </div>
                  ) : null}
                  <div className='new-chat'>
                    {isLoading ? <SummaryLoader /> : !props?.fileChat && GridBoxes()}
                  </div>
                </>
            }
          </div>
          {!type && <div className="chat-bot-input-wrapper col-sm-12 position-relative">
            {isMentioning && (
              <div className="mention-picker" role="listbox" aria-label="File and folder mentions">
                <div className="mention-picker-header">
                  <span>Files and folders</span>
                  <span className="mention-picker-query">@{mentionSearchText}</span>
                </div>
                {mentionResults.length > 0 ? (
                  <div className="mention-picker-list">
                    {mentionResults.map((res, index) => {
                      const mentionType = getMentionType(res);
                      const mentionPath = getMentionPath(res);
                      return (
                        <button
                          key={getMentionId(res)}
                          type="button"
                          role="option"
                          aria-selected={index === activeMentionIndex}
                          className={`mention-picker-row ${index === activeMentionIndex ? 'is-active' : ''}`}
                          onClick={() => handleMentionSelect(res)}
                          onMouseEnter={() => setActiveMentionIndex(index)}
                        >
                          <span className={`mention-picker-icon mention-picker-icon--${mentionType}`}>
                            <FontAwesomeIcon icon={mentionType === 'folder' ? 'folder' : 'file-alt'} />
                          </span>
                          <div className="mention-picker-body">
                            <div className="mention-picker-name" title={getMentionName(res)}>{getMentionName(res)}</div>
                            <div className="mention-picker-meta" title={mentionPath || mentionType}>
                              <span>{mentionType === 'folder' ? 'Folder' : 'File'}</span>
                              {mentionPath ? <span className="mention-picker-path">{mentionPath}</span> : null}
                            </div>
                          </div>
                        </button>
                      )
                    })}
                  </div>
                ) : (
                  <div className="mention-picker-empty">
                    {mentionSearchText.length > 0 ? 'No matching files or folders found.' : 'Start typing to search files and folders.'}
                  </div>
                )}
              </div>
            )}

            <div className="chatbot-input col-sm-12">
              <div
                ref={inputRef}
                className="mention-composer-editor"
                contentEditable
                role="textbox"
                aria-label="Ask or mention files and folders"
                data-placeholder="Ask or type @ to mention files and folders"
                suppressContentEditableWarning
                onInput={handleComposerInput}
                onKeyDown={handleInputKeyDown}
                onPaste={handleComposerPaste}
              />
              <button onClick={handleSend} disabled={disableButton}>
                <FontAwesomeIcon
                  className='genderIconAlignment'
                  color='#fff'
                  icon='paper-plane'
                  data-toggle="tool-tip"
                  title='Send'
                />
              </button>
            </div>
          </div>}
        </div>
      </div>
    </div>
  );
};

export default Search;
